export type PanelKeyHostname = {
  hostname: string
}

export const STORAGE_KEY = '@painel-location'
export const PANEL_KEY_HOSTNAME = '@painel-digital:hostname'
export const STORAGE_QUEUE = '@painel-digital:queue'
